/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { SettingName, SettingsService } from '@administration-client/settings-shared';
import {
  ApiResourceService,
  ResourceRepository,
  ResourceServiceConfig,
  SingleResourceReducer,
  SingleResourceState,
  StateService,
  createSingleResourceActions,
} from '@common/tech-shared';
import { Action, ActionReducerMap } from '@ngrx/store';
import { PostfachLinkRel } from './postfach.linkrel';
import { PostfachResource } from './postfach.model';

export const POSTFACH_FEATURE_KEY = 'PostfachState';

export const POSTFACH_PATH = 'postfach';

export class PostfachResourceService extends ApiResourceService<PostfachResource, PostfachResource> {}

export function createPostfachResourceService(
  repository: ResourceRepository,
  settingService: SettingsService,
  stateService: StateService,
) {
  return new ApiResourceService(buildConfig(settingService), stateService, repository);
}

function buildConfig(settingService: SettingsService): ResourceServiceConfig<PostfachResource> {
  return {
    stateInfo: { name: POSTFACH_FEATURE_KEY, path: POSTFACH_PATH },
    baseResource: settingService.get(SettingName.POSTFACH),
    getLinkRel: PostfachLinkRel.SELF,
    edit: { linkRel: PostfachLinkRel.SELF },
  };
}

export function postfachResourceReducer(state: SingleResourceState, action: Action) {
  const resourceReducer: SingleResourceReducer = new SingleResourceReducer(
    createSingleResourceActions({ name: POSTFACH_FEATURE_KEY, path: POSTFACH_PATH }),
  );
  return resourceReducer.reducer(state, action);
}

export const postfachReducer: ActionReducerMap<any> = {
  [POSTFACH_PATH]: postfachResourceReducer,
};
